var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({class:`btn waves-effect waves-light ${_vm.isDisabled ? 'disabled' : ''} ${_vm.className}`,attrs:{"href":_vm.href,"title":_vm.title}},'a',_vm.$attrs,false),[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }